import { render } from "./PPCSettingsSection.vue?vue&type=template&id=08130e47&scoped=true"
import script from "./PPCSettingsSection.vue?vue&type=script&lang=js"
export * from "./PPCSettingsSection.vue?vue&type=script&lang=js"

import "./PPCSettingsSection.vue?vue&type=style&index=0&id=08130e47&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08130e47"]])

export default __exports__